// 系统支持的语言列表
export const localesMap = {
    en: 'English',
    // zh: '中文',
};

// 类型定义，表示支持的语言类型
export type TLocals = keyof typeof localesMap;
// 默认语音
export const defaultLocale = 'en';

// 将 localesMap 的键值对转换为 Locales 对象
// 例如：{ en: 'en', zh: 'zh' }
export const Locales = Object.fromEntries(Object.keys(localesMap).map(key => [key, key])) as { [key in TLocals]: key };
